import IntegrationService from "@/services/integration.service"

export const initialRemoteVariables = {
  integrations: null,
  metrics_mapping: { contact_first_name: "contact_first_name", contact_last_name: "contact_last_name" },
  metrics_mapping_ids: null,
  platform_metric_mappings: []
}

export const initialLocalVariables = {
  integrations_sync_stats: {},
  integrations_conn_stats: {}
}

const initialState = { ...initialRemoteVariables, ...initialLocalVariables }

export const integration = {
  namespaced: true,
  state: initialState,
  actions: {
    getIntegrations({ commit }) {
      return IntegrationService.getIntegratedServices().then(
        (response) => {
          commit("setIntegrations", response.data.results)
          return Promise.resolve(response.data.results)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    setIntegrationService({ commit }, data) {
      commit("setIntegrationService", data)
    },

    getMetricsMapping({ commit }) {
      return IntegrationService.getMetricsMapping().then(
        (response) => {
          // commit("setMetricsMapping", response.data)

          const mapping_with_ref_name = {}
          const mapping_with_id = {}
          Object.keys(response.data).forEach((key) => {
            if (key.includes("reference_name")) {
              mapping_with_ref_name[key.replace(/_reference_name/g, "")] = response.data[key]
            } else {
              mapping_with_id[key] = response.data[key]
            }
          })

          commit("setMetricsMapping", {
            mapping_with_ref_name,
            mapping_with_id,
            platform_metric_mappings: response.data.platform_metric_mappings
          })
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    updateServiceSyncStatus: {
      root: true,
      handler({ commit }, data) {
        if (data?.status == "done") {
          setTimeout(() => {
            // in 2 minutes remove the sync status
            commit("removeIntegrationSyncStatus", data["origin"])
          }, 120000)
        }
        commit("setIntegrationSyncStatus", data)
      }
    },
    updateIntegrationConnStatus: {
      root: true,
      handler({ commit }, data) {
        commit("updateIntegrationConnStatus", { origin: data["origin"], status: data["status"] })
      }
    }
  },

  mutations: {
    stateReset(state) {
      Object.assign(state, initialState)
    },
    updateIntegrationConnStatus(state, data) {
      state.integrations_conn_stats[data["origin"]] = data["status"]
    },
    setIntegrationSyncStatus(state, data) {
      state.integrations_sync_stats[data["origin"]] = data
    },
    removeIntegrationSyncStatus(state, integration_origin) {
      delete state.integrations_sync_stats[integration_origin]
    },
    setIntegrations(state, integrations) {
      state.integrations = integrations
    },
    setIntegrationService(state, data) {
      const index = state.integrations.findIndex((int) => int.origin == data["origin"])
      state.integrations.splice(index, 1, data)
    },
    setMetricsMappings(state, data) {
      state.metrics_mapping = data
      state.platform_metric_mappings = data?.platform_metric_mappings
      if (data) {
        data?.platform_metric_mappings.forEach((obj_map) => {
          state.metrics_mapping[`${obj_map.object_type}_${obj_map.option}_metric`] = obj_map.reference_name
        })
      }
    },
    setMetricsMapping(state, { mapping_with_ref_name, mapping_with_id, platform_metric_mappings }) {
      state.metrics_mapping = mapping_with_ref_name
      state.metrics_mapping_ids = mapping_with_id
      state.platform_metric_mappings = platform_metric_mappings
    }
  }
}
